import request from '@/utils/request'

// 查询列表
export function apiScpMrpScheduleNamesListTwo (query) {
  return request({
    url: '/scp/scpMrpScheduleNames/listTwo',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiScpMrpScheduleNamesNewExport (data) {
  return request({
    url: '/scp/scpMrpScheduleNames/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiUpdateScpMrpScheduleNames (data) {
  return request({
    url: '/scp/scpMrpScheduleNames',
    method: 'put',
    data: data
  })
}

// 新增
export function apiAddScpMrpScheduleNames (data) {
  return request({
    url: '/scp/scpMrpScheduleNames',
    method: 'post',
    data: data
  })
}

// 删除
export function apiDelScpMrpScheduleNames (id) {
  return request({
    url: `/scp/scpMrpScheduleNames/${id}`,
    method: 'delete'
  })
}
